import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { Form, Localization, Layout, Core } from 'connex-cds';
import { useTicketContext } from '../../../TicketContext';
import { StyledSelect, StyledTextarea, mobileStyle } from './style';
import { Products } from '../acceptance/costAndPayments/products/Products';
import { Summary } from '../acceptance/costAndPayments/summary/Summary';

const { Container, Column, Row } = Layout;
const { useTranslateMessage } = Localization;

const Styled = styled.div`
  ${mobileStyle}
`;

const testId = 'paymentMethodGrid';

export const PaymentMethodMobile = ({ handleChange, handleAmountChange, productsData }) => {
  const { ticket, paymentMethod } = useTicketContext();
  const { values } = Form.useFormContext();
  const translateMessage = useTranslateMessage();

  return (
    <Styled className={cn('payment-method-mobile')}>
      <Container className={cn('payment-method-options')}>
        <Row className={cn('payment-method-row')}>
          <Column>
            <StyledSelect
              data-testid={`${testId}-method-select`}
              value={values?.isExpectedPaymentMethod ? paymentMethod?.id : 'other'}
              name="isExpectedPaymentMethod"
              onChange={handleChange}
            >
              <option value="" selected disabled hidden>
                {translateMessage('method')}
              </option>
              <option data-testid={`${testId}-expected-option`} value={paymentMethod?.id}>
                {paymentMethod?.name}
              </option>
              <option data-testid={`${testId}-other-option`} value="other">
                {translateMessage('otherPaymentMethod')}
              </option>
            </StyledSelect>
          </Column>
          <Column>
            <Core.Input
              data-testid={`${testId}-amount-input`}
              name="paymentAmount"
              type="number"
              onChange={handleAmountChange}
              value={values?.paymentAmount}
              placeholder={translateMessage('amount')}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <StyledTextarea
              data-testid={`${testId}-additional-textarea`}
              name="paymentAdditionalInfo"
              value={values?.paymentAdditionalInfo}
              placeholder={translateMessage('typeAdditionalInfo')}
              minRows={10}
              onChange={handleChange}
            ></StyledTextarea>
          </Column>
        </Row>
      </Container>
      <Products productsData={productsData} values={values} />
      <Summary
        products={productsData}
        orderPricing={ticket?.priceSummary}
        pricing={values?.pricing}
        paymentAmount={values?.paymentAmount}
        paymentMethod={values?.isExpectedPaymentMethod ? paymentMethod?.id : 'other'}
      />
    </Styled>
  );
};
